import './App.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { DOCUMENT_UPLOAD_LIMIT_FOR_INDIVIDUAL_DOC, FETCHING_APPLICANT_DETAILS, FILE_SIZE_LIMIT_EXCEEDED, SUBMIT_CUSTOMER_DOCUMENTS } from './utils/constants';
import {
  getApplicantDetailsForDocumentUpload, logVerificationResponse,
  sendOtpToMobileNumber, submitDocuments, verifyOtpFromApi,
  getMaskedPhoneAndEmail
} from './services/axiosAPI';
import DocumentList from './components/DocumentList';
import ToastBox from './components/ToastBox';
import { CustomLoader } from './components/CustomLoader';
import ApplicantDetails from './components/ApplicantDetails';
import { AddressAndLogo } from './components/AddressAndLogo';
import { Message } from './components/Message';
import OtpTimer from './components/OtpTimer';
import { DocumentContext } from './contexts/DocumentContext';
import axios from 'axios';

function App() {


  const GET_OTP_BTN = 'GET_OTP_BTN'
  const RESEND_BTN = 'RESEND_BTN'
  const OTP_EXPIRY_TIME = 60 //TIME in seconds

  const [percentageUpload, setPercentageUpload, sectionName, setSectionName] = useContext(DocumentContext);
  const [allDocumentDetails, setallDocumentDetails] = useState([]);
  const [applicantDetails, setapplicantDetails] = useState();
  const [activityDetails, setActivityDetails] = useState();
  const [urlParameters, setUrlParameters] = useState();
  const [error, setError] = useState();
  const [isShowTimer, setIsShowTimer] = useState(false);
  const [counter, setCounter] = useState(OTP_EXPIRY_TIME);

  const [isLoading, setIsLoading] = useState(
    {
      show: false,
      message: "Please wait, while we are proccessing your request."
    }
  );
  const [isVerified, setisVerified] = useState(false);
  const [isGetOtpButtonClicked, setIsGetOtpButtonClicked] = useState(true);
  const [isOtpDisable, setIsOtpDisable] = useState(true);
  const [isShowResendButton, setIsShowResendButton] = useState(false);
  const [message, setMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();

  const [leadID, setLeadID] = useState('');
  const [activityID, setactivityID] = useState('')
  const [eventCODE, seteventCODE] = useState('')
  const [coApplicant, setCoApplicant] = useState('')
  const [maskedMobileNumber, setMaskedMobileNumber] = useState('')
  const [mobileOtp, setMobileOtp] = useState("");
  const [mobileToken, setMobileToken] = useState("");
  const [applicantType, setMappedApplicantType] = useState('');

  const useFocus = () => {
    const htmlElRef = useRef(null)
    const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }
    return [htmlElRef, setFocus]
  }

  const [inputRef, setInputFocus] = useFocus();

  useEffect(() => {
    setInputFocus();
  }, [isOtpDisable]);

  useEffect(() => {
    let search = window.location.search
    let params = new URLSearchParams(search)
    let requestedActivityId = params.get('activityid')
    let coapplicant = params.get('coapplicant');
    coapplicant = coapplicant ? coapplicant : "0";
    let eventcode = params.get('eventcode')

    setactivityID(requestedActivityId);
    seteventCODE(eventcode);
    setCoApplicant(coapplicant);

    // Only for places where mapped value is required
    setMappedApplicantType(
      APPLICANT_TYPE_MAPPING(coapplicant)
    );

    if (!requestedActivityId) setError('Activity Id is not provided in the URL.');
    if (!coapplicant) setError('Coapplicant Id is not provided in the URL.');
    if (!eventcode) setError("Event Code is not provided in the URL.");

    setIsLoading({
      show: true,
      message: "Please wait while we are fetching applicants details."
    })

    fetchMaskedEmailAndMobile(requestedActivityId,
      eventcode,
      coapplicant,)

    /*
  if (coapplicant && requestedActivityId) {
    getApplicantDetails(requestedActivityId, coapplicant);
  }*/

  }, []);


  useEffect(() => {
    if (isVerified) {
      setIsLoading({
        show: true,
        message: "Please wait while we load your customer document upload form."
      });
      getApplicantDetails(
        activityID,
        coApplicant
      ).finally(() => {
        setIsLoading({ show: false, message: "" });
      });

    }

  }, [isVerified]);


  const APPLICANT_TYPE_MAPPING = (applicantType) => {
    // Define the mapping for the applicant types based on the number
    const applicantTypes = {
      0: "mainApplicant",
      1: "coApplicantOne",
      2: "coApplicantTwo",
      3: "coApplicantThree",
      4: "coApplicantFour",
      5: "coApplicantFive",
      6: "coApplicantSix",
      7: "coApplicantSeven",
      8: "coApplicantEight",
      9: "coApplicantNine",
      10: "coApplicantTen"
    };
    // Return the mapped applicant type or a default value if not found
    return applicantTypes[applicantType] || "unknownApplicant";
  };

  /*******************Fetched Masked Email and Phone ******************************* */
  const fetchMaskedEmailAndMobile = async (activityId,
    eventCode,
    coapplicant) => {
    await getMaskedPhoneAndEmail(
      activityId,
      eventCode,
      coapplicant
    )
      .then((response) => {
        if (response?.data?.statusCode) {
          setIsLoading({
            show: false,
            message: ""
          });
          if (response?.data?.statusCode === 200) {
            let maskedEmailPhoneResp = (response?.data?.message);
            console.log("Masked email and phone resp >>>", maskedEmailPhoneResp);
            console.log("Masked phone resp >>>", maskedEmailPhoneResp.maskedMobile);
            setMaskedMobileNumber(maskedEmailPhoneResp.maskedMobile);
            setLeadID(maskedEmailPhoneResp.leadid)

            if (response?.data?.message?.custDocUploaded?.status === "conflict") {
              let responseOfApplicants = response?.data?.message?.custDocUploaded?.data;
              setSuccessMessage(responseOfApplicants);
            }

            setIsLoading({ show: false, message: "" });

          } else {
            let err = response?.data?.message;
            setError(err);
          }
        }
      })
      .catch((error) => {
        setIsLoading({
          show: false,
          message: ""
        });
        if (error.toString().includes('504')) {
          setError(error.toString())
        } else {
          setError(' Internal Server Error , Please contact to support team.')
        }
      })
  }

  const getApplicantDetails = async (requestedActivityId, coapplicant) => {
    console.log("applicant type and token value is >>>>", { applicantType, mobileToken })
    setIsLoading({ show: true, message: FETCHING_APPLICANT_DETAILS });
    getApplicantDetailsForDocumentUpload(requestedActivityId, coapplicant, applicantType, mobileToken).then((response) => {

      if (response?.data?.message?.status === "success") {
        let responseList = response?.data?.message?.data;
        console.log("responseList==", responseList);
        if (typeof responseList === "string") responseList = JSON.parse(responseList);
        setallDocumentDetails(responseList?.documentListArray);
        delete responseList?.documentListArray;
        setActivityDetails({
          activityid: responseList?.activityid,
          eventcode: responseList?.eventcode,
          leadid: responseList?.leadid,
          applicanttype: responseList?.applicanttype,
          isOtpEnabled: responseList?.isOtpEnabled
        })
        const isOtpMandatory = responseList?.isOtpEnabled;

        if (isOtpMandatory === "false") {
          setisVerified(true);
        }

        delete responseList?.activityid;
        delete responseList?.eventcode;
        delete responseList?.leadid;
        delete responseList?.applicanttype;
        delete responseList?.isOtpEnabled;
        setapplicantDetails(responseList)
      } else if (response?.data?.message?.status === "conflict") {
        let responseOfApplicants = response?.data?.message?.data;
        setSuccessMessage(responseOfApplicants);
      }

      setIsLoading({ show: false, message: "" });
    }).catch((error) => {
      console.error("Error occured ", error?.response?.data?.message);
      if (error?.response?.data?.message?.error) {
        setError(error?.response?.data?.message?.error)
      }
      setIsLoading({ show: false, message: "" });
    })
  }

  const [isShowToast, setisShowToast] = useState({
    show: false,
    toastType: "",
    toastMessage: ""
  });

  const handleToast = (value) => {
    setisShowToast(
      {
        show: value,
        toastType: "",
        toastMessage: ""
      }
    )
  }

  const handleRemoveFile = (indexOfFileSection, indexOfFile) => {
    let ObjectOfallDocumentDetails = allDocumentDetails[indexOfFileSection];
    let ArrayOfDocumentValue = [];
    ArrayOfDocumentValue = ObjectOfallDocumentDetails['Document_Value'];

    if (ArrayOfDocumentValue) {
      ArrayOfDocumentValue.splice(indexOfFile, 1);
    }
    ObjectOfallDocumentDetails['Document_Value'] = ArrayOfDocumentValue;

    let tempArray = allDocumentDetails;
    tempArray[indexOfFileSection] = ObjectOfallDocumentDetails;
    setallDocumentDetails([...tempArray]);
  }
  const logResponse = async (status, applicantType, token) => {
    let actDtls = {
      activityid: activityID,
      eventcode: eventCODE,
      leadid: leadID,
      applicanttype: applicantType
    }
    console.log("act details >>>", actDtls)
    await logVerificationResponse(actDtls, status, applicantType, token);
  }
  const otpVerifiedSuccess = () => {
    setisVerified(true);
    setInputFocus()
    setIsShowTimer(false)
  }

  const handleOtp = async (inputOtp) => {
    if (inputOtp.length === 6) {
      await verifyOtp(activityID, applicantType, inputOtp);
    }
  }
  const otpClickAction = async (actionName) => {
    if (actionName === GET_OTP_BTN) {
      await sendOtp(activityID, applicantType)

    } else if (actionName === RESEND_BTN) {
      await reSendOtp(activityID, applicantType)

    }
  }

  const sendOtp = async (activityID, applicantType) => {
    setIsLoading({
      show: true,
      message: 'Please wait while we are sending OTP to your registered mobile number.'
    });
    setMessage()
    await sendOtpToMobileNumber(activityID, applicantType)
      .then((response) => {
        if (response?.data?.statusCode === 200 && response?.data?.message?.status === 'failure') {
          setMessage('You are re-trying too early. Please wait for some time.')
          setIsLoading({
            show: false,
            message: ''
          });
        } else if (response?.data?.statusCode === 200 &&
          response?.data?.message?.statusCode === 200 && response?.data?.message?.status === 'success') {
          setMessage(`OTP has been sent to mobile number ${maskedMobileNumber}`)
          otpSendSuccess();
          setIsOtpDisable(false);
          setInputFocus();
        } else {
          setMessage(`Failed to sent OTP to mobile number ${maskedMobileNumber}`)
          setIsLoading({
            show: false,
            message: ''
          });
        }
      })
      .catch((error) => {
        console.warn('error >> ', error);
        setMessage(`Failed to sent OTP  ${error}`)
        setIsLoading({
          show: false,
          message: ''
        });
      })
  }
  const reSendOtp = async (activityID, applicantType) => {
    setIsLoading({
      show: true,
      message: 'Re-Sending OTP to your registered mobile number.'
    });
    setMessage()
    await sendOtpToMobileNumber(activityID, applicantType)
      .then((response) => {
        if (response?.data?.statusCode === 200 && response?.data?.message?.status === 'failure') {
          setMessage('You are re-trying too early. Please wait for some time.')
          setIsLoading({
            show: false,
            message: ''
          });
        } else if (response?.data?.statusCode === 200 &&
          response?.data?.message?.statusCode === 200 && response?.data?.message?.status === 'success') {
          setMessage(`OTP has been Re-sent to mobile number ${maskedMobileNumber}`)
          otpSendSuccess();
          setIsOtpDisable(false);
          setInputFocus();
        } else {
          setMessage(`Failed to Re-sent OTP to mobile number ${maskedMobileNumber}`)
          setIsLoading({
            show: false,
            message: ''
          });
        }
      })
      .catch((error) => {
        console.warn('error >> ', error);
        setMessage(`Failed to Re-sent OTP  ${error}`)
        setIsLoading({
          show: false,
          message: ''
        });
      })
  }

  const verifyOtp = async (activityID, applicantType, otp) => {
    setIsLoading({
      show: true,
      message: "Please wait while we are verifying OTP."
    })
    setMessage('Verifying OTP, please wait.');
    setIsOtpDisable(true);
    await verifyOtpFromApi(activityID, applicantType, otp)
      .then((response) => {
        const token = response?.data?.message?.result?.token ?? "";
        console.log("Mobile token is >>>", token)

        if (response?.data?.statusCode === 200 &&
          response?.data?.message?.status === "failure") {

          console.log("Mobile token is 1>>>", token)

          setMobileToken(token)

          logResponse("false", applicantType, token)
          setMessage(`OTP could not verified. This OTP is incorrect.`);
          setIsOtpDisable(false);
        } else if (
          response?.data?.statusCode === 200 &&
          response?.data?.message?.statusCode === 200 &&
          response?.data?.message?.status === "success"
        ) {
          let verifyResponse = response?.data?.message?.result;

          console.log("verify Otp Response is >>>", verifyResponse);

          console.log("Mobile token is 2>>>", token)
          setMobileToken(token)

          logResponse("true", applicantType, token);
          setMessage(`OTP verified successfully.`)
          otpVerifiedSuccess()
        } else {
          setMessage(`OTP Verification failed.`)
          setIsOtpDisable(false);
        }
      })
      .catch((error) => {
        console.warn('error ', error)
        setMessage(`OTP Verification failed. ${error}`);
        setIsOtpDisable(false);
      })
  }

  const otpSendSuccess = () => {
    setIsLoading({
      show: false,
      message: ''
    });
    setIsShowTimer(true)
    setIsGetOtpButtonClicked(false)
  }
  const otpCounter = (time) => {
    setCounter(time)
    if (!isVerified && time === 0) {
      setIsShowResendButton(true)
    }
  }
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
  const uploadFileHandler = async (event, fileName, index) => {
    let ObjectOfallDocumentDetails = allDocumentDetails[index];

    let ArrayOfDocumentValue = [];
    ArrayOfDocumentValue = ObjectOfallDocumentDetails['Document_Value'];
    let documentSchema = ObjectOfallDocumentDetails['Document_Schema'];
    let sectionName = ObjectOfallDocumentDetails['Document_Name'];

    setSectionName(sectionName);

    const fileList = event.target.files;
    for (let i in fileList) {
      const file = fileList[i];
      if (file.size > Number(process.env.REACT_APP_DOCUMENT_FILE_SIZE)) {
        document.getElementById("fileInput_" + index).value = "";
        setisShowToast({
          show: true,
          toastType: "Error",
          toastMessage: FILE_SIZE_LIMIT_EXCEEDED
        })
        return false;
      }
      if (ArrayOfDocumentValue.length >= Number(process.env.REACT_APP_DOCUMENT_UPLOAD_LIMIT)) {
        setisShowToast({
          show: true,
          toastType: "Warning",
          toastMessage: DOCUMENT_UPLOAD_LIMIT_FOR_INDIVIDUAL_DOC + " " + "for the section " + fileName
        })
        return false;
      }
      if (typeof file !== "number" && typeof file !== "function") {

        const base64OfuploadedImage = await getBase64(file);

        await sendFileToTemporaryLocation({ activityDetails: activityDetails, name: file.name, value: base64OfuploadedImage, schema: documentSchema }, applicantType, mobileToken)
          .then((response) => {
            if (response?.data?.message?.data) {
              setPercentageUpload(0)
              let responseFile = response?.data?.message?.data;
              ArrayOfDocumentValue.push({ name: file.name, value: responseFile });
              setisShowToast({
                show: true,
                toastType: "Success",
                toastMessage: `File ${file.name} has been uploaded.`
              })
            }
          })
          .catch((error) => {
            document.getElementById("fileInput_" + index).value = "";
            setPercentageUpload(0)
            console.error("error ", error);


            if (error?.response?.data?.servermessage) {
              let merror = error?.response?.data?.servermessage || error?.response?.data?.message;
              setisShowToast({
                show: true,
                toastType: "Error",
                toastMessage: merror
              })
            } else if (error?.response?.data?.message?.error) {
              setisShowToast({
                show: true,
                toastType: "Error",
                toastMessage: error?.response?.data?.message?.error
              })
            } else {
              setisShowToast({
                show: true,
                toastType: "Error",
                toastMessage: "Failed to upload file."
              })
            }
          })
      }
    }
    ObjectOfallDocumentDetails['Document_Value'] = ArrayOfDocumentValue;

    let tempArray = allDocumentDetails;
    tempArray[index] = ObjectOfallDocumentDetails;
    setallDocumentDetails([...tempArray]);
  };

  const fileSubmitHandler = (event) => {
    event.preventDefault();

    for (let i in allDocumentDetails) {
      const docs = allDocumentDetails[i];
      if (docs && docs['Document_Value'] && docs['Document_Value'].length === 0) {
        setisShowToast({
          show: true,
          toastType: "Error",
          toastMessage: `Documents are not found in ${docs['Document_Name']} section.`
        })
        return false;
      }
    }
    setIsLoading({ show: true, message: SUBMIT_CUSTOMER_DOCUMENTS });
    submitDocuments(allDocumentDetails, activityDetails, applicantType, mobileToken)
      .then((response) => {
        if (response?.data?.message?.data) {
          let responseMessage = response?.data?.message?.data;
          setSuccessMessage(responseMessage)
        }
        setIsLoading({ show: false, message: "" });
      })
      .catch((error) => {
        console.error("error ", error);
        setIsLoading({ show: false, message: "" });
        if (error?.response?.data?.servermessage) {
          let merror = error?.response?.data?.servermessage || error?.response?.data?.message;
          setisShowToast({
            show: true,
            toastType: "Error",
            toastMessage: merror
          })
        } else if (error?.response?.data?.message?.error) {
          setisShowToast({
            show: true,
            toastType: "Error",
            toastMessage: error?.response?.data?.message?.error
          })
        } else {
          setisShowToast({
            show: true,
            toastType: "Error",
            toastMessage: "Failed to submit uploaded files."
          })
        }
      })

  };

  const sendFileToTemporaryLocation = async (body, applicantType, token) => {
    var config = {
      method: "POST",

      url: "https://pstech.leadsquaredapps.com/lapp-proxy",

      headers: {
        "Content-Type": "application/json"
      },
      maxContentLength: 100000000,
      maxBodyLength: 1000000000,
      // timeout: 0,
      data: {
        method: "post",
        params: {
          stage: process.env.REACT_APP_ENVIRONMENT,
          name: process.env.REACT_APP_CUSTOMER_DOCUMENT_UPLOAD_API,
          operationType: "uploadfile"
        },
        orgId: process.env.REACT_APP_ORGID,
        data: {
          lappBody: {
            files: body,
            "tokenDetails": {
            token: `${token}`,
            activityId: `${body.activityDetails.activityid}`,
            coApplicant: `${applicantType}`,
            type: 'documentUpload',
          }
          }
        }
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percentage = Math.floor((loaded * 100) / total) - 3;
        if (percentage <= 100) {
          setPercentageUpload(percentage);
        }
      }
    }
    return await axios(config);
  }
  return (

    <>

      {isLoading.show && (
        <div className="App">
          <CustomLoader message={isLoading.message} />
        </div>
      )}
      {!isLoading.show && error && (
        <div className="App">
          <div className="container pt-2 pb-2 mt-5">
            <div className="custom-template alert-danger custom-template-danger">
              <h3>Something Went Wrong!</h3 ><br></br>
              <h5>❌{error}</h5>
            </div >
          </div >
        </div >
      )}

      {!isLoading.show && !error && successMessage && (
        <div className="">
          <div className="container pt-2 pb-2 mt-5">
            <div className="custom-template custom-template-success " >
              <div className='row'>
                <div className='col col-sm-8 col-md-8 col-lg-10 col-xl-10'>
                  <img
                    width={270}
                    height={270}
                    alt='poonalogo.jpg'
                    src="./poonalogo.jpg"
                    className="img-fluid"
                  ></img>
                </div>
                <div className='col col-sm-4 col-md-4 col-lg-2 col-xl-2'>

                </div>
              </div>
              <h3 className='text-center'>{successMessage}</h3>
            </div>
          </div>
        </div>
      )}

      {!isLoading.show && !error && isVerified && !successMessage ? (
        <>
          {!applicantDetails && (
            <CustomLoader message="Please wait while we load your customer document upload form." />
          )}

          {!error && !isLoading.show && applicantDetails && (
            <div className="container pt-2 pb-2" >
              <div className="custom-template" >
                <AddressAndLogo />
                <div className="row text-center mt-4">
                  <p className='h5 text-center'>
                    <strong>Customer Document Upload</strong>
                  </p>
                </div>
                {/* <form > */}
                {applicantDetails && (
                  <>
                    <div className="card mt-3 ">
                      <div className="card-header">
                        <strong>Applicant Details</strong>
                      </div>
                      <table className="table text-left">
                        <tbody>
                          {applicantDetails && Object.keys(applicantDetails).map((data, index) => {
                            return (
                              <ApplicantDetails key={"Applicant_" + index} heading={data} body={applicantDetails[data]} />
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}

                {allDocumentDetails && allDocumentDetails.map((docs, index) => {
                  return (
                    <DocumentList key={index} index={index} docs={docs} uploadFileHandler={uploadFileHandler} handleRemoveFile={handleRemoveFile} />
                  )
                })}

                {allDocumentDetails && allDocumentDetails.length > 0 && (
                  <div className="mt-4 mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-lg-auto col-xl-auto text-end text-sm-end text-md-end text-lg-end text-xl-end">
                    <button
                      onClick={fileSubmitHandler}
                      type='button'
                      className="btn btn-sm btn-mx btn-blue col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Disagree consent"
                    >
                      Submit
                    </button>
                  </div>
                )}

                {/* </form> */}
              </div>
              {/* end */}
            </div >
          )}
        </>
      ) : !isLoading.show && !error && !isVerified && !successMessage && (
        <>
          <div className="container pt-2 pb-2 mt-5">
            <div className="custom-template" >
              <AddressAndLogo />
              <div className='row mt-5'>
                <h6>
                  <strong>
                    Dear Customer, kindly enter the OTP sent on your registered mobile number {maskedMobileNumber} to upload your documents.
                  </strong></h6>
              </div>
              <div className="row mt-4">
                <div className="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
                  <label className="col-form-label thead">Mobile Number</label>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <input
                    type="text"
                    placeholder="Enter Mobile Number"
                    className="form-control"
                    value={maskedMobileNumber}
                    disabled={true}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Mobile number cannot be change from here."
                  />
                </div>

                <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 pt-3 pt-sm-3 pt-md-2 pt-lg-0 pt-xl-0 ">
                  <div className="form">
                    <input
                      id="otpf"
                      type="number"
                      placeholder="Enter OTP"
                      onChange={(e) => handleOtp(e.target.value.trim())}
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Enter the OTP"
                      disabled={isOtpDisable}
                      maxLength={6}
                      className="otpfield"
                      ref={inputRef}
                    />
                    {isGetOtpButtonClicked && (
                      <button
                        className="in-button"
                        type="button"
                        disabled={isLoading.show}
                        onClick={() => otpClickAction(GET_OTP_BTN)}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Get OTP to regisered mobile number."
                      >
                        Get OTP
                      </button>
                    )}

                    {isShowResendButton && (
                      <button
                        className="in-button"
                        type="button"
                        disabled={isLoading.show}
                        onClick={() => otpClickAction(RESEND_BTN)}
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Resend OTP"
                      >
                        Resend OTP
                      </button>
                    )}
                    {isVerified && (
                      <img
                        alt='tick'
                        className="tick"
                        src="./tick.svg"
                        width="25%"
                        height="25%"
                      />
                    )}
                  </div>

                  {message && <Message message={message} color="green" />}
                  {isShowTimer && (
                    <>
                      <OtpTimer otpCounter={otpCounter} counter={counter} />
                    </>
                  )}
                </div>
              </div>
            </div>

          </div>
        </>
      )}

      {isShowToast.show && (
        <ToastBox handleToast={handleToast} toastType={isShowToast.toastType} toastMessage={isShowToast.toastMessage} />
      )}
    </>


  );
}

export default App;
